<template>
  <check-base-layout :pagetitle="pagetitle"
                     :checkInfoData="checkFrom">
    <template>
      <check-module
        :title="`合同总览`">
        <compart-module
          :compartData="checkFrom.purchaseContractBasesVo"
          :is-customer="false"></compart-module>
      </check-module>
      <check-module
        :tabsdata="tabsdata"
        :activeName="activeName"
        :is-table="true"
        @tabclick="tabclick">
        <info-table
          :field-arr="bFieldArr"
          :table-data="tableData"
          :table-height="`300px`"
          :to-fixed-format="['purchasePrice','discountPrice','amountPaid','proPrice']"
        ></info-table>
        <div class="allfield_title">总计</div>
        <info-table
          :field-arr="allFieldArr"
          :table-data="aTableData"
          :to-fixed-format="['purchaseTotal','discountTotal','actualTotal']"
          :table-height="aTableData.length ? `73px` : 'auto'"></info-table>
      </check-module>
    </template>
    <template v-slot:checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVo"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'

export default {
  name: 'stockupCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '采购报缺审批'
    }
  },
  data () {
    return {
      bFieldArr: [{
        name: 'brandName',
        label: '品牌'
      }, {
        name: 'seriesName',
        label: '系列'
      }, {
        name: 'proName',
        label: '产品名称'
      }, {
        name: 'proModel',
        label: '型号'
      }, {
        name: 'proOrderNum',
        label: '订货号'
      }, {
        name: 'pccCount',
        label: '数量'
      }, {
        name: 'proUnit',
        label: '单位'
      }, {
        name: 'proExtype',
        label: '类型'
      }, {
        name: 'pcbExtimeValue',
        label: '货期',
        formatter (val) {
          if (!val) return '--'
          const d = val.split('-')
          if (d.length !== 2) return val + '天'
          return val + '天'
        }
      }, {
        name: 'purchasePrice',
        label: '采购单价'
      }, {
        name: 'discountPrice',
        label: '折扣金额'
      }, {
        name: 'amountPaid',
        label: '实付单价'
      }, {
        name: 'proPrice',
        label: '面价'
      }],
      tabsdata: [
        {
          label: '报缺清单',
          name: 'a'
        },
        {
          label: '产品清单',
          name: 'b'
        }
      ],
      checkFrom: {
        orderContractBaseOtherPayVo: {}
      },
      tableData: [],
      aTableData: [],
      activeName: 'a'
    }
  },
  computed: {
    allFieldArr () {
      const { activeName } = this
      if (activeName === 'a') {
        return [{
          name: 'lackCount',
          label: '报缺数量'
        }, {
          name: 'purchaseTotal',
          label: '采购总价'
        }, {
          name: 'discountTotal',
          label: '抵扣金额'
        }, {
          name: 'actualTotal',
          label: '实付金额'
        }]
      }
      return [{
        name: 'purchaseTotal',
        label: '采购总价'
      }, {
        name: 'discountTotal',
        label: '抵扣金额'
      }, {
        name: 'actualTotal',
        label: '实付金额'
      }]
    }
  },
  watch: {
    activeName (val) {
      const { checkFrom } = this
      this.checkFrom = deepClone(checkFrom)
      return val
    },
    checkFrom (checkFrom) {
      checkFrom = this.formatterData(checkFrom)
      const { purchaseContractLackProductVo, purchaseContractProductVo } = checkFrom
      const { activeName } = this
      // 报缺清单
      if (purchaseContractLackProductVo && purchaseContractLackProductVo.purchaseContractLackProductsVoList && activeName === 'a') {
        const {
          lackCount,
          purchaseTotal,
          discountTotal,
          actualTotal
        } = purchaseContractLackProductVo
        this.tableData = purchaseContractLackProductVo.purchaseContractLackProductsVoList
        this.aTableData = [{
          lackCount,
          purchaseTotal,
          discountTotal,
          actualTotal
        }]
      } else {
        // 产品清单
        const {
          lackCount,
          purchaseTotal,
          discountTotal,
          actualTotal
        } = purchaseContractProductVo
        this.tableData = purchaseContractProductVo.purchaseContractProductsVoList
        this.aTableData = [{
          lackCount,
          purchaseTotal,
          discountTotal,
          actualTotal
        }]
      }
      this.$emit('update:data', checkFrom)
      return checkFrom
    }
  },
  mounted () {
    this.getPoLackCheckInfo()
  },
  methods: {
    getPoLackCheckInfo () {
      const {
        snaId
      } = this
      checkApi.getPoLackCheckInfo({
        snaId
      }).then(res => {
        if (isSuccess(res)) {
          this.checkFrom = deepClone(res.data.obj)
        }
      })
    },
    tabclick (e) {
      this.activeName = e
    }
  }
}
</script>

<style scoped>
  .el-icon-warning-outline {
    padding-right: 10px;
  }

  .allfield_title {
    padding: 20px 0 14px;
    font-size: 14px;
    font-weight: 500;
  }
</style>
